export default __webpack_public_path__ + "static/media/estenometro.60c0fd75.png";